@if (data && data.enableHeader) {
<div class="preview-header-screen" [class.mobile-view]="viewMode === 'mobile'"
  [style.background-color]="data.backgroundColor">
  <div class="preview-header-screen-content"
    [class.mobile-view]="viewMode === 'mobile'"
    [style.align-items]="data.alignment"
    [style.text-align]="data.textAlign">
    @if (data.imageUrl) {
    <div class="preview-header-screen-image-wrap" [class.mobile-view]="viewMode === 'mobile'" [style.justify-content]="data.imageAlignment">
      <img 
      [class.mobile-view]="viewMode === 'mobile'"
      [src]="data.imageUrl" alt="Header"
        [style.width]="data.imageSizePx + 'px'" [style.height]="'auto'" [style.object-fit]="'contain'" />
    </div>
    }
    <h3 
    [class.mobile-view]="viewMode === 'mobile'"
    class="preview-header-screen-title p-0 m-0"
      [style.color]="data.titleColor" [style.font-size]="data.titleFontSize + 'px'"
      [style.font-family]="data.titleFontFamily" [style.font-weight]="data.titleFontWeight">
      {{ data.title }}
    </h3>
    <p 
    [class.mobile-view]="viewMode === 'mobile'"
    class="preview-header-screen-description p-0 m-0"
      [style.color]="data.descriptionColor" [style.font-size]="data.descriptionFontSize + 'px'"
      [style.font-family]="data.descriptionFontFamily" [style.font-weight]="data.descriptionFontWeight"
      [style.text-align]="data.descriptionTextAlign">
      {{ data.description }}
    </p>
  </div>
</div>
}
